import classNames from 'classnames';
import React, { ButtonHTMLAttributes, forwardRef } from 'react';
import { colors } from 'components/styles/variables';

const ButtonTransparent = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement>>(
  ({ children, className = '', ...props }, ref) => {
    return (
      <>
        <button
          {...props}
          ref={ref}
          role="button"
          className={classNames('button-transparent', className)}
        >
          {children}
        </button>
        <style jsx>{`
          .button-transparent {
            margin: 0;
            padding: 0;
            text-transform: none;
            box-sizing: unset;
            color: ${colors.BLACK};
            background-color: transparent;
            border: none;
          }
          .button-transparent:hover {
            background-color: transparent;
            border: none;
          }
        `}</style>
      </>
    );
  }
);

export default ButtonTransparent;
